import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NamingGuidelinesComponent } from '../naming-guidelines/naming-guidelines.component';

@Component({
  selector: 'app-channel-tnc',
  standalone: true,
  imports: [MatDialogModule, FormsModule],
  templateUrl: './channel-tnc.component.html',
  styleUrls: ['./channel-tnc.component.css'],
})
export class ChannelTncComponent {
  constructor(public dialogRef: MatDialogRef<NamingGuidelinesComponent>) {}

  ok(): void {
    this.dialogRef.close();
  }
}
